import { apiFetch } from './apiClient';

/* Configurações › Acesso de clientes: logins de cliente e módulos de NF liberados */
export const listarAcessosClientes = () => apiFetch('/portal-clientes');
export const criarAcessoCliente = (dados) => apiFetch('/portal-clientes', { method: 'POST', body: JSON.stringify(dados) });
export const atualizarAcessoCliente = (id, dados) => apiFetch(`/portal-clientes/${id}`, { method: 'PATCH', body: JSON.stringify(dados) });
